import "../component css/SkillsTicker.css";

const SKILLS = [
  "HTML", "CSS", "JavaScript", "TypeScript", "React", "Next.js", "Node.js",
  "Python", "PHP", "C++", "SQL", "MySQL", "Bootstrap", "WordPress",
  "Git", "GitHub", "Figma", "Photoshop", "Illustrator", "After Effects",
  "Linux", "Canva", "ChatGPT", "Gemini", "Claude",
];

const items = [...SKILLS, ...SKILLS];

export default function SkillsTicker() {
  return (
    <div className="skills-ticker" aria-label="Skills">
      <div className="skills-ticker__track">
        <div className="skills-ticker__inner">
          {items.map((skill, i) => (
            <span key={i} className="skills-ticker__item">
              {skill}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
